var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticClass: "cancel-request-dialog",
      attrs: {
        fullscreen: false,
        "close-on-press-escape": true,
        "show-close": false,
        "close-on-click-modal": false,
        visible: _vm.visible,
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
      },
    },
    [
      _c("div", { staticClass: "cancel-request-header" }, [
        _c("div", { staticClass: "cancel-order" }, [
          _vm._v("\n      Cancel Order\n    "),
        ]),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "el-dialog__headerbtn",
            attrs: { type: "button", "aria-label": "Close" },
            on: {
              click: function ($event) {
                return _vm.$emit("update:visible", false)
              },
            },
          },
          [_c("i", { staticClass: "el-dialog__close el-icon el-icon-close" })]
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticStyle: { border: "1px solid #DEE5EC" } }),
      _vm._v(" "),
      _c("div", { staticClass: "cancel-request-body" }, [
        _c("div", { staticClass: "warning-img" }, [
          _c("img", {
            staticStyle: {
              height: "48px",
              width: "100%",
              padding: "6px 0px 6px 4px",
            },
            attrs: { src: require("../../../../assets/warning-icon.svg") },
          }),
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "order-number-1",
            staticStyle: { padding: "0px !important" },
          },
          [
            _vm._v(
              "\n      Cancel Order #" +
                _vm._s(
                  _vm.order.order.displayable_order_id ||
                    _vm.order.order.order_id
                ) +
                "?\n    "
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "cancel-order-description",
            staticStyle: { padding: "0px !important" },
          },
          [
            _vm._v(
              "\n      This will stop the order and refund the customer using their original payment method."
            ),
            _c("br"),
            _vm._v(" "),
            _c("br"),
            _vm._v("This cannot be undone.\n    "),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticStyle: { padding: "16px 40px 24px 40px" } }, [
        _c("div", { staticClass: "flex flex-row cancel-order-buttons" }, [
          _c(
            "div",
            { staticStyle: { width: "50%" } },
            [
              _c(
                "el-button",
                {
                  staticClass: "keep-order-button",
                  staticStyle: {
                    border: "1px solid #d4231a",
                    "border-radius": "8px",
                    color: "#d4231a",
                  },
                  attrs: { "aria-label": "Close" },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("update:visible", false)
                    },
                  },
                },
                [_vm._v("\n          Keep Order\n        ")]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticStyle: { width: "50%" } },
            [
              _c(
                "el-button",
                {
                  staticClass: "cancel-order-button",
                  staticStyle: {
                    background: "#d4231a",
                    "border-radius": "8px",
                    color: "#ffffff",
                  },
                  on: { click: _vm.cancel_order },
                },
                [_vm._v("\n          Cancel Order\n        ")]
              ),
            ],
            1
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }